// These constants are used to determine if the extended warranty should be enabled. It should not rely on external libraries as it is used in the frontend extension.

export const CART_ATTRIBUTE_KEY = "extended-warranty-selections";

export enum ExtendedWarrantyCartToggleExperience {
  TOGGLE = "toggle",
  MODAL = "modal",
  REMOVE_ONLY = "remove_only",
  CHECKBOX = "checkbox",
  DISABLED = "disabled",
}

export enum ExtendedWarrantyPdpRenderMethod {
  APP_BLOCK = "app_block",
  SCRIPT_TAG = "script_tag",
}

export enum ExtendedWarrantyPopupExperience {
  EMBEDDED = "embedded",
  DISABLED = "disabled",
}
